module.exports = __webpack_public_path__ + "img/bx-5.df2479c1.jpg";